export const pendingResults = (state) => state.results.pending;
export const raceResults = (state) => state.results.raceResults;
export const raceResultById = (state, raceId) => state.results.raceResults.find((race) => race.id === raceId);
